import { render, staticRenderFns } from "./setPublishPreview.vue?vue&type=template&id=6469bd0a"
import script from "./setPublishPreview.vue?vue&type=script&lang=js"
export * from "./setPublishPreview.vue?vue&type=script&lang=js"
import style0 from "./setPublishPreview.vue?vue&type=style&index=0&id=6469bd0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports